import type { FrAupaStaticFileIdFormat } from '../model.ts'

export const frAupaGeneralTermsStaticFileId_v1_0_0 =
  'fr-aupa-general-terms-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaIpidStaticFileId_v1_0_0 = 'fr-aupa-ipid-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaAssistanceSilverGeneralTermsStaticFileId_v1_0_0 =
  'fr-aupa-assistance-silver-general-terms-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaAssistanceGoldGeneralTermsStaticFileId_v1_0_0 =
  'fr-aupa-assistance-gold-general-terms-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaAssistanceGoldPlusGeneralTermsStaticFileId_v1_0_0 =
  'fr-aupa-assistance-gold-plus-general-terms-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaAssistanceSilverIpidStaticFileId_v1_0_0 =
  'fr-aupa-assistance-silver-ipid-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaAssistanceGoldIpidStaticFileId_v1_0_0 =
  'fr-aupa-assistance-gold-ipid-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaAssistanceGoldPlusIpidStaticFileId_v1_0_0 =
  'fr-aupa-assistance-gold-plus-ipid-v1_0_0' as const satisfies FrAupaStaticFileIdFormat

export const frAupaStaticFilesIds_v1_0_0 = [
  frAupaGeneralTermsStaticFileId_v1_0_0,
  frAupaIpidStaticFileId_v1_0_0,
  frAupaAssistanceSilverGeneralTermsStaticFileId_v1_0_0,
  frAupaAssistanceGoldGeneralTermsStaticFileId_v1_0_0,
  frAupaAssistanceGoldPlusGeneralTermsStaticFileId_v1_0_0,
  frAupaAssistanceSilverIpidStaticFileId_v1_0_0,
  frAupaAssistanceGoldIpidStaticFileId_v1_0_0,
  frAupaAssistanceGoldPlusIpidStaticFileId_v1_0_0,
] as const satisfies readonly FrAupaStaticFileIdFormat[]
